import React from 'react';
import { FaLocationArrow, FaMapMarkerAlt, FaPhone } from 'react-icons/fa';

const ContactAddress = () => {
  return (
    <div className="address">
        {/* <div className="add">
          <div className="icon">
            <FaMapMarkerAlt />
          </div>
          <p>22, 2nd Avenue, Kemta Estate, <br />Idi-Aba, Abeokuta, Ogun State</p>
        </div> */}
        <div className="add">
          <div className="icon">
            <FaPhone />
          </div>
          <p>+923105473346</p>
        </div>
        <div className="add">
          <div className="icon">
            <FaLocationArrow />
          </div>
          <p>thewisekidz2024@gmail.com</p>
        </div>
    </div>
  )
}

export default ContactAddress
